import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID } from '@angular/core';

@Component({
  selector: 'app-thanks2023',
  templateUrl: './thanks2023.component.html',
  styleUrls: ['./thanks2023.component.scss']
})
export class Thanks2023Component {

  constructor(@Inject(PLATFORM_ID) private platformId: Object) { }
  
  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      const iframe = document.getElementsByTagName("iframe")[0];
      iframe.addEventListener("load", function () {
        iframe.contentWindow.postMessage(
          '<meta HTTP-EQUIV="Access-Control-Allow-Origin" CONTENT="https://app.us.luzmo.com/s/bhavani-2023-wh5trefqg0v22ehi">',
          'https://app.us.luzmo.com/s/bhavani-2023-wh5trefqg0v22ehi'
        )
        console.log(iframe.contentWindow.document )
      });
      window.addEventListener(
        "message",
        (event) => {
          if (event.origin !== "https://app.us.luzmo.com/s/bhavani-2023-wh5trefqg0v22ehi") return;
          console.log(event)
        },
        false,
      );
    }
  }
}
